import { CustomDropdown } from '@components'
import { CACHE_KEYS } from '@constants'
import { DetailIcon, DotsIcon, PayoutIcon, RefundIcon } from '@icons'
import cn from '@integrations/classnames'
import { useContext } from '@integrations/react'
import {
  usePayoutInitiateMutation,
  usePayoutPreviewMutation,
  useRefundInitiateMutation,
  useRefundPreviewMutation
} from 'mmfintech-backend-api'
import type { TransactionViewPortal } from 'mmfintech-backend-api/types'
import { GlobalContext, tr } from 'mmfintech-commons'
import PayoutModal from '../PayoutModal'
import RefundModal from '../RefundModal'

interface Props {
  transaction: TransactionViewPortal
  reload: () => void
  enablePayouts: boolean
  enableRefunds: boolean
  handleDetailsClick: (transactionId: number) => void
}

function TransactionDropdown({ transaction, reload, enablePayouts, enableRefunds, handleDetailsClick }: Props) {
  const { modalShow } = useContext(GlobalContext)

  const [_refundPreview, { reset: resetRefundPreview }] = useRefundPreviewMutation({
    fixedCacheKey: CACHE_KEYS.REFUND_PREVIEW
  })
  const [_refundInit, { reset: resetRefundInitiation }] = useRefundInitiateMutation({
    fixedCacheKey: CACHE_KEYS.REFUND_INIT
  })
  const [_payoutPreview, { reset: resetPayoutPreview }] = usePayoutPreviewMutation({
    fixedCacheKey: CACHE_KEYS.PAYOUT_PREVIEW
  })
  const [_payoutInit, { reset: resetPayoutInitiation }] = usePayoutInitiateMutation({
    fixedCacheKey: CACHE_KEYS.PAYOUT_INIT
  })

  function handlePayout() {
    modalShow({
      content: <PayoutModal transaction={transaction} reload={reload} />,
      options: {
        size: 'auto',
        onClose: () => {
          resetPayoutPreview()
          resetPayoutInitiation()
        }
      }
    })
  }

  function handleRefund() {
    modalShow({
      content: <RefundModal transaction={transaction} reload={reload} />,
      options: {
        size: 'auto',
        onClose: () => {
          resetRefundPreview()
          resetRefundInitiation()
        }
      }
    })
  }

  return (
    <CustomDropdown
      icon={<DotsIcon />}
      dropdown={
        <div className={cn('dropdown-container')}>
          <div onClick={() => handleDetailsClick(transaction?.id)}>
            <DetailIcon />
            <p>{tr('FRONTEND.TRANSACTIONS.VIEW_DETAILS_BUTTON', 'View details')}</p>
          </div>
          {enableRefunds ? (
            <div onClick={handleRefund}>
              <RefundIcon />
              <p>{tr('FRONTEND.TRANSACTIONS.REFUND_BUTTON', 'Refund')}</p>
            </div>
          ) : null}
          {enablePayouts ? (
            <div onClick={handlePayout}>
              <PayoutIcon />
              <p>{tr('FRONTEND.TRANSACTIONS.PAYOUT_BUTTON', 'Payout')}</p>
            </div>
          ) : null}
        </div>
      }
    />
  )
}

export default TransactionDropdown
